<div class="customers">
    <div class="divObjetivo">
        <div class="card-body">
            <div class="form-special-padding">
                <div class="row">
                    <div class="col-sm-3" style="background-color: #E8EAF5;">
                        <textarea class="text-area-objetivo" name="consulta" (change)="change()" [(ngModel)]="accionData.accion" [disabled]="true"></textarea>
                    </div>
                    <div class="col-sm-3" style="background-color: #E8EAF5;">
                        <div class="input-group p-3">
                            <div class="jornada">
                                <div class="row">
                                    <div class="col-6 p-2">
                                        Desde:
                                    </div>
                                    <div class="col-6 p-2">
                                        Hasta:
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="input-group p-2">
                                            <input class="form-control" [ngClass]="fechaClass" style="padding: 6px 12px;" name="fechaInicioMedicion" [(ngModel)]="this.fechaInicio" ngbDatepicker #d1="ngbDatepicker" (ngModelChange)="change()" readonly>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="input-group p-2">
                                            <input class="form-control" [ngClass]="fechaClass" style="padding: 6px 12px;" name="fechaFinMedicion" [(ngModel)]="this.fechaFin" ngbDatepicker #d2="ngbDatepicker" (ngModelChange)="change()" readonly>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3" style="background-color: #E8EAF5;">
                        <textarea class="text-area-objetivo" name="consulta" (change)="change()" [(ngModel)]="accionData.medioVerificacion" [disabled]="true"></textarea>
                    </div>
                    <div class="col-sm-3" style="background-color: #E8EAF5;">
                        <textarea class="text-area-objetivo" name="consulta" (change)="change()" [(ngModel)]="accionData.seguimiento"></textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>